import { Spin } from "antd"
import styles from "./SuspenseLoader.module.scss"

const SuspenseLoader = () => (
  <div className={styles.container}>
    <Spin size="default" />
  </div>
)

export default SuspenseLoader
